import React from 'react';
import classNames from 'classnames';

/**
 * A caption component
 *
 * @module NackleCaption
 * @param {Object} props - the component props
 * @param {string} [props.text] - the text in the caption
 * @param {string} [props.state] - the state of the caption
 * @param {number} [props.size] - the size of the caption
 * @param {boolean} [props.disabled] - whether or not the component is disabled
 * @returns {JSX.Element}
**/
const NackleCaption = ( { className, text, state, size, disabled } ) => {
    const captionClasses = classNames( {
        'nackle-caption': true,
        [ state ]: state ? true : false,
        [ className ]: className ? true : false,
        [ size ]: size ? true : false,
        'default': size ? false : true,
        disabled: disabled ? true : false
    } );
   return (
    <div className={ captionClasses }>
        { text }
    </div>
   );
};

export { NackleCaption };
